import { render } from "./UserInfoSection.vue?vue&type=template&id=5a60c520&scoped=true"
import script from "./UserInfoSection.vue?vue&type=script&lang=js"
export * from "./UserInfoSection.vue?vue&type=script&lang=js"

import "../css/UserInfoSection.css?vue&type=style&index=0&id=5a60c520&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a60c520"]])

export default __exports__